// removed by extract-text-webpack-plugin
module.exports = {"statistics":"_39WLvK_LpwCyKgAemi_jxu","statisticsButton":"_1VUoEyMF6mAmEN3Wv94DFx","sButtonItem":"_2eFazFhj0xsFhl4jsJgVY8","line":"_1Kgf7-R4Jsc_tOAs1M3saO"};


//////////////////
// WEBPACK FOOTER
// ./src/components/BaseConsumption/index.less
// module id = 740
// module chunks = 0